module.exports = __webpack_public_path__ + "img/full7-min.c80ccf2c.png";